import { defineComponent } from 'vue';
import SearchDropdownItemCode from '@/presentation/components/rights/rights-search/search-dropdown-item/search-dropdown-item.code';

export default defineComponent({
	props: {
		id: {
			type: Number,
			required: true
		},
		name: {
			type: String,
			required: true
		},
		email: {
			type: String,
			required: true
		}
	},
	setup: (props) => {
		const code = new SearchDropdownItemCode(
			props.id,
			props.name,
			props.email
		);

		return {
			name: props.name,
			email: props.email,
			id: props.id,
			onClick: code.onClick.bind(code)
		};
	}
});
